import DatabaseReturnClientRepository from "@domain/repositories/DatabaseReturnClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { userRoles } from "@domain/models/User";

type Input = void;

type Output = void;

export class WatchReturnsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly databaseReturnClientRepository: DatabaseReturnClientRepository
  ) {}

  execute() {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      return this.databaseReturnClientRepository.watchReturnClientsAdmin();
    }

    if (user.role === userRoles.manager) {
      return this.databaseReturnClientRepository.watchReturnClientsManager(user.operatorsIds);
    }

    if (user.role === userRoles.operator) {
      return this.databaseReturnClientRepository.watchReturnClientsOperator(user.id);
    }

    return;
  }
}
